import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal, DomPortalOutlet, PortalInjector } from '@angular/cdk/portal';
import { DOCUMENT } from '@angular/common';
import { ApplicationRef, ComponentFactoryResolver, Inject, Injectable, InjectionToken, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const CONTAINER_DATA = new InjectionToken<{}>('CONTAINER_DATA');

@Injectable({
  providedIn: 'root'
})
export class FloatPopupService {

	// floatPopupBS: BehaviorSubject<{open: boolean}> = new BehaviorSubject({
	// 	open: false
	// });

	// _overlayRef: OverlayRef;

	_overlayRefs: {
		[i: string]: OverlayRef
	} = {};
	constructor(
		@Inject(DOCUMENT) private document: Document,
		private _appRef: ApplicationRef,
        private _componentFactoryResolver: ComponentFactoryResolver,
        private _injector: Injector,
		private _overlay: Overlay
	) { }

	// openFloatPopup() {
	// 	this.floatPopupBS.next({
	// 		open: true
	// 	})
	// }
	// closeFloatPopup() {
	// 	this.floatPopupBS.next({
	// 		open: false
	// 	})
	// }

	openPopup(component, dataToPass?, panelClassList?: string[]) {
		if (this._overlayRefs[component]) {
			return;
		}
		const classList = ['float-popup-container'];
		if (panelClassList) {
			panelClassList.forEach(i => classList.push(i));
		}
		const overlayRef = this._overlay.create(
			{
				panelClass: classList
			}
		);
		const injector = dataToPass ? this.createInjector(dataToPass) : null;
		const containerComponentPortal = new ComponentPortal(component, null, injector);
		const containerRef = overlayRef.attach(containerComponentPortal);
		this._overlayRefs[component] = overlayRef;

		// const portalOutlet = new DomPortalOutlet(
		// 	containerRef.instance.VCR.element.nativeElement,
		// 	this._componentFactoryResolver,
		// 	this._appRef,
		// 	this._injector
		//   )
		// portalOutlet.attachComponentPortal(new ComponentPortal(component));
		// containerComponentPortal.attach(portalOutlet);
	}
	closePopup(component) {
		this._overlayRefs[component].detach();
		delete this._overlayRefs[component];
	}
	closeAll() {
		Object.keys(this._overlayRefs).forEach(c => this.closePopup(c))
	}

	private createInjector(dataToPass): PortalInjector {
		const injectorTokens = new WeakMap();
		injectorTokens.set(CONTAINER_DATA, dataToPass);
		return new PortalInjector(this._injector, injectorTokens);
	}
	// private _attachDialogContainer(overlay: OverlayRef, config: MatDialogConfig): MatDialogContainer {
	// 	const userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
	// 	const injector = new PortalInjector(userInjector || this._injector, new WeakMap([
	// 	  [MatDialogConfig, config]
	// 	]));
	// 	const containerPortal =
	// 		new ComponentPortal(MatDialogContainer, config.viewContainerRef, injector);
	// 	const containerRef = overlay.attach<MatDialogContainer>(containerPortal);
	
	// 	return containerRef.instance;
	//   }
}
